import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { createConfig } from './app/app.config';

fetch('/api/status')
  .then(response => response.json())
  .then(({ features, configuration }) => {
    bootstrapApplication(
      AppComponent,
      createConfig(configuration.identity, features),
    ).catch(err => console.error(err));
  });
